import Loader from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Col, Form, InputGroup, Table } from "react-bootstrap";
import { Front, List, Plus } from "react-bootstrap-icons";
import NewNumberInput from "../../../Components/NewNumberInput";
import { deleteExtraServiceData, getExtraServiceData, saveExtraService } from "../../store/api/TaskDetailsApi";
import { setDialog } from '../../store/api/GetAllProduct';
import BihamtaTable from '../../../Components/BihamtaTable';
import { getStaffShare } from "../../store/api/Services";
import { setErrorDialog } from "../../../store/api/CommonFunctions";
function ServiceExtraCosts(props) {
    const { serviceInfo, setServiceInfo, setPopSelectStaff, parentStaffID } = props;
    const { fieldList, serviceExtraList, systemSettings } = useSelector(state => {
        return {
            fieldList: state.UserReducer.pageFieldList,
            serviceExtraList: state.taskDetails.serviceExtraList,
            systemSettings: state.SystemSettingsReducer.systemSettings
        }
    });
    const dispatch = useDispatch();
    const [isPending, setPending] = useState(false);
    const [selectedStaff, setStaffData] = useState(null);
    const [isStaffEmpty, setStaffEmpty] = useState(null);
    const roleList = JSON.parse(localStorage.getItem("RoleList"));
    const serviceExtraCost = useRef({});
    const [priceValues, setPriceValues] = useState({ TaxAmount: 0, Discount: 0, UnitCost: 0, PureTotalPrice: 0, Count: 1, TaxPercent: 0 });
    const staffSharesInfo = {
        StaffExtraServicesCostPercentShare: selectedStaff?.StaffExtraServicesCostPercentShare ?? serviceInfo.StaffExtraServicesCostPercentShare,
        StaffExtraServicesCostFixAmountShare: selectedStaff?.StaffExtraServicesCostFixAmountShare ?? serviceInfo.StaffExtraServicesCostFixAmountShare
    }
    const showStaffShare = !(Number(serviceInfo.AgencyID > 0) && serviceInfo.ReceptionInAgent.toString().toLowerCase() === "true");
    const checkFieldPermission = (fieldName, actionType) => {
        let result = actionType === "Read";
        let field = fieldList?.find(f => f.PageName === "Service_Extra" && f.Name === fieldName);
        if (actionType === "Read" && field) {
            result = field.IsRead === true;
        }
        if (actionType === "Edit" && field) {
            result = field.IsUpdate === false;
        }
        return result;
    }
    const saveServiceExtraCost = () => {
        if (isPending) {
            return;
        }
        if (serviceExtraCost.current.Description === "") {
            setErrorDialog(dispatch, "شرح خدمت وارد نشده است.");
        }
        Object.assign(serviceExtraCost.current, priceValues);
        serviceExtraCost.current.ServiceID = serviceInfo?.ServiceID;
        serviceExtraCost.current.ServiceType = serviceInfo?.ServiceType;
        if (!serviceExtraCost.current.UnitCost) {
            serviceExtraCost.current.UnitCost = 0;
        }
        if (!serviceExtraCost.current.Discount) {
            serviceExtraCost.current.Discount = 0;
        }
        let staffID = document.getElementById("Ext_StaffID")?.value;
        if (staffID === '') {
            setStaffEmpty(true);
            return;
        }
        else {
            setStaffEmpty(false);
        }
        if (staffID) {
            serviceExtraCost.current.StaffID = staffID;
        }
        setPending(true);
        dispatch(saveExtraService(serviceExtraCost.current, (res) => {
            setPending(false);
            setPriceValues({ TaxAmount: 0, Discount: 0, UnitCost: 0, PureTotalPrice: 0, Count: 1, TaxPercent: 0 });
            document.querySelectorAll("[extradata]").forEach(el => {
                if (el.type === "number") {
                    if (el.name === "Count") {
                        el.value = 1;
                    }
                    else if (el.name !== "TaxPercent") {
                        el.parentNode.setAttribute("comma-value", 0);
                        el.value = 0;
                    }
                }
                else if (el.type === "text") {
                    el.value = "";
                }
            });
            serviceExtraCost.current = {};
            serviceInfo.AmountCustomerShouldPay = res.AmountCustomerShouldPay;
            serviceInfo.TaxAmount = res.TaxAmount;
            serviceInfo.Discount = res.Discount;
            setServiceInfo({ ...serviceInfo });
        }));
    }
    function onDelete(res) {
        serviceInfo.AmountCustomerShouldPay = res.AmountCustomerShouldPay;
        serviceInfo.TaxAmount = res.TaxAmount;
        serviceInfo.Discount = res.Discount;
        setServiceInfo({ ...serviceInfo });
    }
    function onPriceChanged(name, value) {
        if (!value || value === "") {
            value = 0;
        }
        // if (name === "Cost") {
        //     selectedDefinedService.Cost = Number(value);
        // }
        priceValues[name] = Number(value);
        if (!priceValues.Count) {
            priceValues.Count = 0;
        }
        if (!priceValues.Discount) {
            priceValues.Discount = 0;
        }
        if (!priceValues.TaxPercent) {
            priceValues.TaxPercent = 0;
        }
        if (!priceValues.UnitCost) {
            priceValues.UnitCost = 0;
        }
        if (name !== "StaffShare" && showStaffShare) {
            priceValues.StaffShare = getStaffShare(staffSharesInfo, "extra", priceValues.Discount, Number(priceValues.UnitCost) * Number(priceValues.Count), systemSettings, serviceInfo.ReceptionInAgent, serviceInfo.AgencyID);
        }
        priceValues.TaxAmount = (Number(priceValues.UnitCost) * Number(priceValues.Count) - Number(priceValues.Discount)) * Number(priceValues.TaxPercent) / 100;
        priceValues.PureTotalPrice = Number(priceValues.UnitCost) * Number(priceValues.Count) - Number(priceValues.Discount) + Number(priceValues.TaxAmount);
        setPriceValues({ ...priceValues })
    }
    function onInputFocus(e) { e.target.select() }
    useEffect(() => {
        // let loadExtras = false;
        // if (serviceExtraList && serviceExtraList.length > 0) {
        //     loadExtras = serviceExtraList.some(u => Number(u.ServiceID) === Number(serviceInfo?.ServiceID) && u.ServiceType === serviceInfo?.ServiceType);
        // }
        if (Number(serviceInfo?.ServiceID) > 0 /*&& !loadExtras*/)
            dispatch(getExtraServiceData(serviceInfo?.ServiceID, serviceInfo?.ServiceType));
    }, [])
    const tableColes = [
        { colTitle: "نام تکنسین", colName: "ExtraStaffName", showInMobile: true },
        { colTitle: "شرح خدمت", colName: "ExtraDescription", showInMobile: true },
        { colTitle: "تعداد", colName: "ExtraCount" },
        { colTitle: "قیمت واحد", colName: checkFieldPermission("UnitPrice", "Read") ? "ExtraUnitPrice" : "", colType: "currency" },
        { colTitle: "تخفیف", colName: checkFieldPermission("Discount", "Read") ? "ExtraDiscount" : "", colType: "currency" },
        { colTitle: "مالیات", colName: checkFieldPermission("Tax", "Read") ? "TaxAmount" : "", colType: "currency" },
        { colTitle: "قابل پرداخت", colName: checkFieldPermission("UnitPrice", "Read") ? "PureTotalPrice" : "", colType: "currency" },
        { colTitle: "سهم تکنسین", colName: checkFieldPermission("StaffShare", "Read") ? "ExtraStaffShare" : "", colType: "currency", showCondition: () => showStaffShare },
        { colTitle: "گارانتی", colName: "ExtraHasGuaranty", colType: "boolean" }
    ]
    const tableRowButtons = [
        {
            title: "حذف خدمت", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                if (serviceInfo?.IsArchive !== true && !serviceInfo?.IsNotLastDuration && !serviceInfo.StoppedInStatus) {
                    dispatch(setDialog({
                        status: 'show',
                        arrayBtn: ['yes', 'no'],
                        dialogTitle: 'حذف خدمت',
                        dialogText: 'آیا از حذف مطمئن هستید؟',
                        okOperation: deleteExtraServiceData(serviceInfo?.ServiceID, serviceInfo?.ServiceType, item.ExtraID, (res) => onDelete(res))
                    }))
                }
            }
        }
    ]
    return (
        <Fragment>
            {(serviceInfo?.IsArchive !== true && !serviceInfo?.IsNotLastDuration) &&
                <Fragment>
                    <div className="row">
                        {roleList && roleList.find(s => s === "Reception") && !roleList.find(s => s === "Staff") && !roleList.find(s => s === "Agent") &&
                            <div className='form-group  col-md-2'>
                                <label>تکنسین انجام دهنده کار:</label>
                                <input type='hidden' id="Ext_StaffID" value={selectedStaff ? selectedStaff.ID : serviceInfo?.StaffID ?? ""} readOnly />
                                <input placeholder='تکنسین را انتخاب کنید' type="text" className='form-control' value={selectedStaff ? selectedStaff.LastName : serviceInfo?.StaffName ?? ""} readOnly />
                                <Button className="btn-input-tiny" onClick={() => { setPopSelectStaff({ show: true, onSelect: setStaffData, parentID: parentStaffID }) }}><List size={20} /></Button>
                                {isStaffEmpty === true && <small className='errors'>تکنسین انتخاب نشده است</small>}
                            </div>
                        }
                        <div className="form-group col-md-2">
                            <label>شرح خدمت</label>
                            <input type="text" className="form-control" name="Description" extradata="" onChange={e => serviceExtraCost.current.Description = e.target.value} />
                        </div>
                        <div className="form-group col-md-2">
                            <label>وضعیت گارانتی:</label>
                            <select className='form-control' name="IsGuaranty" extradata="" defaultValue={false} onChange={e=> serviceExtraCost.current.IsGuaranty = e.target.value}>
                                <option value={false} style={{ color: "red" }}>شامل گارانتی نیست</option>
                                <option value={true} style={{ color: "#008058" }}>شامل گارانتی است</option>
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="form-group col-md-2">
                            <label>تعداد</label>
                            <input type="number" name="Count" className="form-control" defaultValue={1} min={1} extradata="" step={0.1} onChange={(e) => onPriceChanged("Count", e.target.value)} onFocus={onInputFocus} />
                        </div>
                        {checkFieldPermission("UnitPrice", "Read") &&
                            <div className="form-group col-md-2">
                                <label>قیمت واحد</label><span style={{ color: "red" }}>*</span>
                                <NewNumberInput inputname="UnitCost" readonly={checkFieldPermission("UnitPrice", "Edit")} defaultvalue={0} minvalue={0} customattr={{ extradata: "" }} onChange={(e) => onPriceChanged("UnitCost", e.target.value)} />
                            </div>
                        }
                        {checkFieldPermission("Discount", "Read") &&
                            <div className="form-group col-md-2">
                                <label>تخفیف</label>
                                <NewNumberInput inputname="Discount" readonly={checkFieldPermission("Discount", "Edit")} defaultvalue={0} minvalue={0} customattr={{ extradata: "" }} onChange={(e) => onPriceChanged("Discount", e.target.value)} />
                            </div>
                        }
                        {checkFieldPermission("Tax", "Read") &&
                            <Col md={2} className="form-group">
                                <div style={{ width: "30%", display: "inline-block" }}>
                                    <label className='ellipsisLabel' title='درصد مالیات'>% مالیات</label>
                                    <Form.Control type='number' defaultValue={0} readOnly={checkFieldPermission("Tax", "Edit")} name="TaxPercent"
                                        extradata="" onChange={(e) => onPriceChanged("TaxPercent", e.target.value)} minvalue={0}
                                        style={{ borderRadius: "0px 4px 4px 0px" }} onFocus={onInputFocus} />
                                </div>
                                <div style={{ width: "70%", display: "inline-block" }}>
                                    <label>مالیات</label>
                                    <NewNumberInput inputname="TaxAmount" readonly={true} value={priceValues.TaxAmount} style={{ borderRadius: "4px 0px 0px 4px", marginRight: "1px" }} customattr={{ extradata: "" }} onFocus={onInputFocus}
                                    />
                                </div>
                            </Col>
                        }
                        <Col md={2} className='form-group'>
                            <label>قابل پرداخت: </label>
                            <NewNumberInput readonly={true} value={priceValues.PureTotalPrice} customattr={{ extradata: "" }} />
                        </Col>
                        {showStaffShare &&
                            <Col md={2} className='form-group'>
                                <label>سهم تکنسین</label>
                                <NewNumberInput inputname="StaffShare" readonly={checkFieldPermission("StaffShare", "Edit")}
                                    value={priceValues?.StaffShare ?? 0} minvalue={0} onChange={(e) => { onPriceChanged("StaffShare", e.target.value) }}
                                    customattr={{ extradata: "" }} />
                            </Col>
                        }
                    </div>
                    <button type="button" className="btn btn-success btn-block group-Btn mt-2" onClick={saveServiceExtraCost} disabled={isPending || serviceInfo.StoppedInStatus}><Plus size={18} />ثبت خدمت</button>
                </Fragment>
            }
            <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} dataList={{ Data: serviceExtraList }} />
        </Fragment>
    )
}
export default ServiceExtraCosts;